













































































import { Vue, Component, Prop, Ref, Watch, Provide } from 'vue-property-decorator'
import {Action, Getter, Mutation} from "vuex-class";
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import { FormRowWings, InputWings, TextareaWings } from 'wings-ui-components';
import { MsgTransports } from '@/store/types';
import { uploadedFile, ViberTemplateItemImpl } from '@/store/templates/types';
import { Route } from 'vue-router';
import {cloneDeep} from "lodash";
import upload from '@/components/Inputs/upload.vue'
import { notifyError } from '@/utils/notify-helper';
import { ViberGenericTemplateInterface } from "@/store/viber/templates/types";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {GenericTemplate, FormRowWings, InputWings, TextareaWings, upload}})
export default class ViberTemplate extends Vue {
  @Ref('genericTemplate') genericTemplate!: ViberGenericTemplateInterface;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  @Action("getFile") actionGetFile: any;
  @Action("uploadFiles") actionUploadFiles: any;
  @Action("deleteFile") actionDeleteFile: any;

  private transport = MsgTransports.VIBER;
  private templateObject = new ViberTemplateItemImpl();
  uploadedFile?: uploadedFile | null = null;
  acceptedFiles = `.doc, .docx, .rtf, .dot, .dotx, .odt, .odf, .fodt, .txt, .info,
    .pdf, .xps, .pdax, .eps, .xls, .xlsx, .ods, .fods, .csv, .xlsm, .xltx`;

  created() {
    this.setTemplate()
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  async onLoadTemplate(template: any) {
    this.$emit('onLoadTemplate', template)
    if (template.attachmentFileId) {
      try {
        const resp = await this.actionGetFile(template.attachmentFileId);
        this.uploadedFile = resp.data;
      } catch(error) {
        notifyError(error)
      }
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: any) {
    this.genericTemplate.beforeLeave(to, from, next);
  }

  get atLeastOneIsFull(): boolean {
    return !!this.template.image || !!this.template.buttonName || !!this.template.buttonLink;
  }

  async onFileChanged(event: any) {
    if (!event.target.files[0]) return;

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    try {
      const resp = await this.actionUploadFiles(formData);
      this.uploadedFile = resp.data;
      this.template.attachmentFileId = resp.data?.id;
      this.template.buttonLink = undefined;
      this.template.image = undefined;
    } catch(error) {
      notifyError(error);
    }
  }

  async deleteFile() {
    try {
      const resp = await this.actionDeleteFile(this.template.attachmentFileId);
      this.template.attachmentFileId = null;
      this.uploadedFile = null;
    } catch(error) {
      notifyError(error)
    }
  }

  onPasteEventHandler(event: any) {
    if (event?.clipboardData?.files?.length > 0) {
      //@ts-ignore
      this.$refs.fileInput.files = event.clipboardData.files;
      //@ts-ignore
      this.$refs.fileInput.dispatchEvent(new Event('change'));
    }
  }

  onDropEventHandler(event: any) {
    if (event?.dataTransfer?.files?.length > 0) {
      //@ts-ignore
      this.$refs.fileInput.files = event.dataTransfer.files;
      //@ts-ignore
      this.$refs.fileInput.dispatchEvent(new Event('change'));
    }
  }

  private customValidateTemplate(): string | undefined {
    const hasText = !!this.template.message?.trim();
    const hasImage = !!this.template.image?.trim();
    const hasButtonName = !!this.template.buttonName?.trim();
    const hasButtonLink = !!this.template.buttonLink?.trim();
    const hasFile = !!this.template.attachmentFileId;

    if (hasButtonName && !hasButtonLink && !hasFile) {
      return this.$tc('errors.viber_button_requires_link_or_file');
    }

    if (!hasText && !hasImage && !hasButtonName && !hasButtonLink && !hasFile) {
      return this.$tc('errors.viber_custom_content_validation');
    }
  }

  mounted() {
    const originalValidate = this.genericTemplate.validator.validate;

    this.genericTemplate.validator.validate = async (...args: any[]): Promise<boolean> => {
      const baseValid = await originalValidate.apply(this.genericTemplate.validator, args);
      const customError = this.customValidateTemplate();

      if (customError) {
        this.genericTemplate.validator.errors._content = [customError];
        return false;
      }

      return baseValid;
    };
  }
}
